const route = {
    path: '/users',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "users" */ '../../components/views/users/users.vue'),
                tabBar:
                    () => import(/* webpackChunkName: "users" */ '../../components/views/users/tabBar.vue'),
            }
        },
        {
            path: 'groups',
            children: [
                {
                    path: '',
                    components: {
                        default:
                            () => import(/* webpackChunkName: "users" */ '../../components/views/users/groups/groups.vue'),
                        tabBar:
                            () => import(/* webpackChunkName: "users" */ '../../components/views/users/tabBar.vue'),
                    }
                },
                {
                    path: ':id',
                    components: {
                        default:
                            () => import(/* webpackChunkName: "users" */ '../../components/views/users/groups/group.vue'),
                    }
                },
            ],
        },
        {
            path: ':id',
            components: {
                default:
                    () => import(/* webpackChunkName: "users" */ '../../components/views/users/user.vue'),
            }
        },
    ],
}

module.exports = route;